<!-- 系统管理：用户管理 -->
<template>
  <div class="user-management-page">
    <!-- 左右布局容器 -->
    <div class="main-container">
      <!-- 左侧：角色管理 -->
      <RoleManagement
        ref="roleManagement"
        :selectedRoleId="selectedRoleId"
        @role-select="handleRoleSelect"
        @role-delete="handleRoleDelete"
        @role-update="handleRoleUpdate"
      />

      <!-- 右侧：Tab切换内容 -->
      <div class="right-panel">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick">
          <!-- 成员账户Tab -->
          <el-tab-pane label="成员账户" name="accounts">
            <AccountList 
              :selectedRoleId="selectedRoleId"
            />
          </el-tab-pane>
          
          <!-- 角色权限Tab -->
          <el-tab-pane label="角色权限" name="permissions">
            <RolePermission 
              :selectedRoleId="selectedRoleId"
              :selectedRole="selectedRole"
              :selectedRolePermissions="selectedRolePermissions"
              @role-updated="handleRoleUpdated"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

  </div>
</template>

<script>
import RoleManagement from './components/RoleManagement.vue';
import AccountList from './components/AccountList.vue';
import RolePermission from './components/RolePermission.vue';

export default {
  name: "UserManagement",
  components: {
    RoleManagement,
    AccountList,
    RolePermission,
  },
  data() {
    return {
      activeTab: 'accounts',
      selectedRoleId: null,
      selectedRole: null,
      selectedRolePermissions: [],
    };
  },
  methods: {
    /* Tab切换 */
    handleTabClick(tab) {
      if (tab.name === 'permissions' && !this.selectedRoleId) {
        this.$message.warning('请先选择一个角色');
        this.$nextTick(() => {
          this.activeTab = 'accounts';
        });
      }
    },
    
    /* 角色选择 */
    handleRoleSelect(role) {
      console.log('Selected Role:', role);
      if (role === null) {
        // 取消选中
        this.selectedRoleId = null;
        this.selectedRole = null;
        this.selectedRolePermissions = [];
      } else {
        this.selectedRoleId = role.id;
        this.selectedRole = role;
        this.selectedRolePermissions = role.role_menu ? role.role_menu.split(",") : [];
      }
    },
    
    /* 角色删除 */
    handleRoleDelete(roleId) {
      if (this.selectedRoleId === roleId) {
        this.selectedRoleId = null;
        this.selectedRole = null;
        this.selectedRolePermissions = [];
      }
    },
    
    /* 角色更新 */
    handleRoleUpdate(roleId) {
      // 如果更新的是当前选中的角色，可以重新加载角色信息
      // 这里暂时不做处理，因为角色管理组件会自动刷新列表
    },
    
    /* 角色信息更新（从权限页面） */
    handleRoleUpdated(updatedRole) {
      // 更新当前选中的角色信息
      this.selectedRole = {
        ...this.selectedRole,
        role_name: updatedRole.role_name,
        role_status: updatedRole.role_status,
        role_menu: updatedRole.role_menu
      };
      this.selectedRolePermissions = updatedRole.role_menu ? updatedRole.role_menu.split(",") : [];
      
      // 通知角色管理组件刷新列表
      if (this.$refs.roleManagement) {
        this.$refs.roleManagement.getRoleList();
      }
    },
  }
};
</script>

<style scoped lang="less">
.user-management-page {
  width: 100%;
  height: 100%;
  padding: 0;
}

.main-container {
  display: flex;
  height: 100%;
  gap: 10px;
}

/* 右侧面板 */
.right-panel {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  
  ::v-deep .el-tabs {
    display: flex;
    flex-direction: column;
    height: 100%;
    
    .el-tabs__header {
      margin: 0;
      padding: 0 20px;
      background: #fafafa;
      border-bottom: 1px solid #e8e8e8;
    }
    
    .el-tabs__nav-wrap {
      padding: 8px 0 0;
    }
    
    .el-tabs__item {
      font-size: 15px;
      font-weight: 500;
      height: 42px;
      line-height: 42px;
      
      &.is-active {
        color: #3d8dfc;
      }
    }
    
    .el-tabs__active-bar {
      background-color: #3d8dfc;
      height: 3px;
      pointer-events: none;
    }
    
    .el-tabs__content {
      flex: 1;
      overflow: hidden;
    }
    
    .el-tab-pane {
      height: 100%;
      overflow: hidden;
    }
  }
}
</style>
